// extracted by mini-css-extract-plugin
export default {"vmvValeurs":"VMVValeurs_vmvValeurs__-7Y2n","vmvValeurs__valeurs":"VMVValeurs_vmvValeurs__valeurs__vxBxI","vmvValeurs__valeurs__item":"VMVValeurs_vmvValeurs__valeurs__item__Ze+qf"};